import { render, staticRenderFns } from "./FarmAdd.vue?vue&type=template&id=0d6fcace&scoped=true&"
import script from "./FarmAdd.vue?vue&type=script&lang=js&"
export * from "./FarmAdd.vue?vue&type=script&lang=js&"
import style0 from "./FarmAdd.vue?vue&type=style&index=0&id=0d6fcace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fcace",
  null
  
)

export default component.exports